import {
  GraphQLID,
  GraphQLInt,
  GraphQLString,
  GraphQLObjectType,
  GraphQLNonNull
} from 'graphql'

export interface QuickFilter {
  readonly id: string
  readonly count: number
  readonly name: string
}

export const QuickFilterType = new GraphQLObjectType({
  name: 'QuickFilter',
  description: 'A predefined filter for various searchable entities',
  fields: () => ({
    id: {
      description: 'The unique ID for the filter',
      type: new GraphQLNonNull(GraphQLID)
    },
    count: {
      description: "The number of this filter's results",
      type: new GraphQLNonNull(GraphQLInt)
    },
    name: {
      description: 'A displayable name for the filter',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})
